import { FunctionComponent } from "react";
import styled from "styled-components";

import Cross from "./cross";

const ErrorBallWrapper = styled.div`
  border-radius: 50%;
  height: 40px;
  width: 40px;
  background-color: ${({ theme }) => theme.customTheme.palette.ErrorBallWrapper.bgColor};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px auto;

  path {
    stroke: ${({ theme }) => theme.customTheme.palette.ErrorBallWrapper.stroke};
  }
`;

const ErrorBall: FunctionComponent = () => (
  <ErrorBallWrapper>
    <Cross />
  </ErrorBallWrapper>
);

export default ErrorBall;
